import { PageHeader } from "@/components/app/kit";
import { AuditTable } from "@/components/app/AuditTable";

export default function PlatformAudit() {
  return (
    <div>
      <PageHeader eyebrow="Traçabilité" title="Journaux d'audit" subtitle="Toutes les actions sensibles de la plateforme et des cabinets : connexions, créations, modifications, désactivations." />
      <AuditTable path="/platform/audit" showTenant />
    </div>
  );
}
